import { Chip } from "@mui/material";
import "./flip-card.css";
interface FlipCardProps {
  title: string;
  body: string;
  buttonLink: string;
  imageLink: string;
  chipList: string[];
}
function FlipCardComponent({
  title,
  body,
  buttonLink,
  imageLink,
  chipList,
}: FlipCardProps) {
  return (
    <div>
      <div className="flip-card" tabIndex={0}>
        <div className="flip-card-inner">
          <div
            className="flip-card-front"
            style={{
              backgroundImage: `url(${imageLink})`,
            }}
          >
            <div className="front-bottom-line">
              <div className="front-title">{title}</div>
              <div className="front-chips">
                <div className="chip-wrapper">
                  {chipList.map((chip, index) => (
                    <div className="front-chip" key={index}>
                      <Chip
                        size="small"
                        color="primary"
                        style={{ backgroundColor: "var(--purple_c)" }}
                        label={chip}
                      />
                    </div>
                  ))}
                  {/* Duplicate the chip list to create a loop */}
                  {chipList.map((chip, index) => (
                    <div className="front-chip" key={`${index}-duplicate`}>
                      <Chip
                        size="small"
                        color="primary"
                        style={{ backgroundColor: "var(--purple_c)" }}
                        label={chip}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="flip-card-back">
            <h3>{title}</h3>
            <p>{body}</p>
            <a
              href={buttonLink}
              className="buttonLinkFlip"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>{" "}
    </div>
  );
}

export default FlipCardComponent;
